import { SwingResult } from '../models/swing';

export function swingResultLabel(result: SwingResult | null | undefined): string {
  switch (result) {
    case 'DBL_THUMB_DWN':
      return '👎👎';
    case 'THUMB_DWN':
      return '👎';
    case 'THUMB_UP':
      return '👍';
    case 'DBL_THUMB_UP':
      return '👍👍';
    default:
      return '';
  }
}

export function swingFeelLabel(result: SwingResult | null | undefined): string {
  switch (result) {
    case 'DBL_THUMB_DWN':
      return 'Two thumbs down';
    case 'THUMB_DWN':
      return 'Thumbs down';
    case 'THUMB_UP':
      return 'Thumbs up';
    case 'DBL_THUMB_UP':
      return 'Two thumbs up';
    default:
      return 'Average';
  }
}
